import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_audio",
  "use": "micro_audio-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_audio\"><path fill-rule=\"evenodd\" d=\"M4 5.05A2.5 2.5 0 1 0 6 7.5L5 2h5V0H3l1 5.05Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol